(function (angular) {
  "use strict";

  var HEADING_HISTORY_MAX_LENGTH = 2;

  angular.module("Toyota.Directives").directive("tyRangeSpinnerPaintSelector", [
    "Animations",
    "DebugLogger",
    "SitecoreAnalytics",
    "$timeout",
    function (Animations, DebugLogger, SitecoreAnalytics, $timeout) {
      var controller = [
        "$scope",
        "$analytics",
        "$attrs",
        "RangeSorting",
        function ($scope, $analytics, $attrs, RangeSorting) {
          var ctl = this;

          angular.extend(ctl, {
            roofPaintsDisplay: [],
            paintOrdering: [],
            selectedBodyPaint: null,
            selectedBodyPaintNameHistory: [],
            selectedRoofPaint: null,
            selectedRoofPaintNameHistory: [],
            savedBodyPaint: null,
            savedRoofPaint: null,
          });

          function getBodyPaintWithRoofOptionsById(bodyPaintId) {
            return ctl.bodyPaints.find(function (bodyPaint) {
              return bodyPaint.id === bodyPaintId;
            });
          }

          function getRoofPaintById(roofPaintId) {
            return ctl.roofPaints.find(function (roofPaint) {
              return roofPaint.id === roofPaintId;
            });
          }

          $scope.setAndSaveBodyPaintById = function (bodyPaintId) {
            DebugLogger.log("tyRangeSpinnerPaintSelector", "setAndSaveBodyPaintById", bodyPaintId);
            var bodyPaint = getBodyPaintWithRoofOptionsById(bodyPaintId);
            ctl.savedBodyPaint = bodyPaint;
            ctl.onBodyPaintSave(bodyPaintId);

            triggerBodyPaintActiveSelectionAnalyticsEvent(bodyPaint.name);
          };

          $scope.setAndSaveRoofPaintById = function (roofPaintId) {
            var roofPaint = getRoofPaintById(roofPaintId);
            ctl.savedRoofPaint = roofPaint;
            ctl.onRoofPaintSave(roofPaintId);

            triggerRoofPaintActiveSelectionAnalyticsEvent(roofPaint.name);
          };

          function paintsToSwatches(paints) {
            return paints.map(function (paint) {
              return angular.extend({}, paint, {
                id: paint.id,
                description: paint.name,
                hex: paint.hexCode,
                image: paint.swatch,
              });
            });
          }

          function triggerBodyPaintActiveSelectionAnalyticsEvent(bodyPaintDescription) {
            $analytics.eventTrack("selectBodyPaint", {
              eventType: "click",
              category: bodyPaintDescription,
            });
          }

          function triggerRoofPaintActiveSelectionAnalyticsEvent(roofPaintDescription) {
            $analytics.eventTrack("selectRoofPaint", {
              eventType: "click",
              category: roofPaintDescription,
            });
          }

          function init() {
            $scope.$watch("tyRangeSpinnerPaintSelector.bodyPaints", function (newBodyPaints, oldBodyPaints) {
              if (newBodyPaints === oldBodyPaints && $scope.tyRangeSpinnerPaintSelector.bodyPaintSwatches) {
                return;
              }

              $scope.tyRangeSpinnerPaintSelector.bodyPaintSwatches = paintsToSwatches(newBodyPaints);

              DebugLogger.log("tyRangeSpinnerPaintSelector", "bodyPaints changed to", newBodyPaints);
            });

            $scope.$watch("tyRangeSpinnerPaintSelector.roofPaints", function (newRoofPaints, oldRoofPaints) {
              if (newRoofPaints === oldRoofPaints && $scope.tyRangeSpinnerPaintSelector.roofPaintSwatches) {
                return;
              }

              DebugLogger.log("tyRangeSpinnerPaintSelector", "roofPaints changed to", newRoofPaints);

              if (ctl.showRoofPaints) {
                ctl.roofPaintsDisplay = angular.copy(ctl.roofPaints);

                $scope.tyRangeSpinnerPaintSelector.roofPaintSwatches = paintsToSwatches(ctl.roofPaints);
                DebugLogger.log("tyRangeSpinnerPaintSelector", "roofPaintsDisplay changed to", newRoofPaints);
              }
            });

            $scope.$watch(
              "tyRangeSpinnerPaintSelector.selectedBodyPaintId",
              function (newSelectedBodyPaintId, oldSelectedBodyPaintId) {
                if (newSelectedBodyPaintId === oldSelectedBodyPaintId && ctl.selectedBodyPaint) {
                  return;
                }

                window.PageLoadCounter = Number(window.PageLoadCounter) + 1;
                DebugLogger.log(
                  "tyRangeSpinnerPaintSelector",
                  "selectedBodyPaintId changed to",
                  newSelectedBodyPaintId
                );

                $scope.$applyAsync(function () {
                  var paint = getBodyPaintWithRoofOptionsById(newSelectedBodyPaintId);
                  var paintName = paint.bodyPaintName;
                  ctl.selectedBodyPaint = paint;
                  if (
                    ctl.selectedBodyPaintNameHistory.length === 0 ||
                    ctl.selectedBodyPaintNameHistory[0] !== paintName
                  ) {
                    ctl.selectedBodyPaintNameHistory.unshift(paintName);
                    ctl.selectedBodyPaintNameHistory = ctl.selectedBodyPaintNameHistory.slice(
                      0,
                      HEADING_HISTORY_MAX_LENGTH
                    );
                  }
                });

                emitBodyPaintChange();
              }
            );

            $scope.$watch(
              "tyRangeSpinnerPaintSelector.selectedRoofPaintId",
              function (newSelectedRoofPaintId, oldSelectedRoofPaintId) {
                if (newSelectedRoofPaintId === oldSelectedRoofPaintId && ctl.selectedRoofPaint) {
                  return;
                }

                DebugLogger.log(
                  "tyRangeSpinnerPaintSelector",
                  "selectedRoofPaintId changed to",
                  newSelectedRoofPaintId
                );

                $scope.$applyAsync(function () {
                  var paint = getRoofPaintById(newSelectedRoofPaintId);
                  ctl.selectedRoofPaint = paint;
                  var paintName = paint.roofPaintName || paint.bodyPaintName;
                  if (
                    ctl.selectedRoofPaintNameHistory.length === 0 ||
                    ctl.selectedRoofPaintNameHistory[0] !== paintName
                  ) {
                    ctl.selectedRoofPaintNameHistory.unshift(paintName);
                    ctl.selectedRoofPaintNameHistory = ctl.selectedRoofPaintNameHistory.slice(
                      0,
                      HEADING_HISTORY_MAX_LENGTH
                    );
                  }
                });

                emitRoofPaintChange();
              }
            );
          }

          function emitBodyPaintChange() {
            ctl.onBodyPaintChange(ctl.selectedBodyPaintId);
          }

          function emitRoofPaintChange() {
            ctl.onRoofPaintChange(ctl.selectedRoofPaintId);
          }

          ctl.$onInit = init;
        },
      ];

      var firstRender = true;

      var link = function ($scope, $element, $attrs, ctrl, transclude) {
        transclude($scope, function (clone) {
          $element.append(clone);
        });

        var $roofPaint = $element.find('[data-js="ty-range-spinner-roof-paint-selector"]');
        Animations.hide($roofPaint);

        $scope.$watch("tyRangeSpinnerPaintSelector.showRoofPaints", function (newShowRoofPaints, oldShowRoofPaints) {
          if (!firstRender && newShowRoofPaints === oldShowRoofPaints) {
            return;
          }
          else
            firstRender = false;

          if (newShowRoofPaints !== oldShowRoofPaints)
            DebugLogger.log("tyRangeSpinnerPaintSelector", "showRoofPaints changed to", newShowRoofPaints);

          if (newShowRoofPaints) {
            ctrl.roofPaintsDisplay = angular.copy(ctrl.roofPaints);
            DebugLogger.log("tyRangeSpinnerPaintSelector", "roofPaintsDisplay changed to", ctrl.roofPaintsDisplay);

            $timeout(function () {
              Animations.slideThenFadeIn($roofPaint);
            });
          } else {
            Animations.fadeThenSlideOut($roofPaint);
          }
        });
      };

      return {
        scope: {
          bodyPaints: "<bodyPaints",
          roofPaints: "<roofPaints",
          showRoofPaints: "<showRoofPaints",
          selectedBodyPaintId: "<selectedBodyPaintId", // this drives selectedBodyPaint
          selectedRoofPaintId: "<selectedRoofPaintId", // this drives selectedRoofPaint
          onBodyPaintChange: "<onBodyPaintChange",
          onRoofPaintChange: "<onRoofPaintChange",
          onBodyPaintSave: "<onBodyPaintSave",
          onRoofPaintSave: "<onRoofPaintSave",
          bodyPaintSelectionGoalId: "@bodyPaintSelectionGoalId",
          roofPaintSelectionGoalId: "@roofPaintSelectionGoalId",
        },
        transclude: true,
        restrict: "A",
        controller: controller,
        controllerAs: "tyRangeSpinnerPaintSelector",
        bindToController: true,
        link: link,
      };
    },
  ]);
})(window.angular);
